/**
 * Generates the liquid tag for a component based on its name.
 * Uses single quotes to workaround a Beefree serialization issue where nested
 * double quotes in Dynamic URL / src attributes get a leading space
 * (e.g. "Image" → " image").
 *
 * @param componentName - The name of the component
 * @returns The liquid tag string (e.g., "{% message_component 'Subject' %}")
 */
export const generateComponentTag = (componentName: string | null | undefined): string => {
  if (!componentName) {
    return "";
  }
  return `{% message_component '${componentName}' %}`;
};
